/**
 * CLP Filter AJAX — Kein-Reload-Filtern für die CLP-Komponenten.
 *
 * Fängt Klicks auf .clp-filter-bar__pill / .clp-vendor-filter__tile ab, holt die
 * Ziel-URL und tauscht zwei Sections per shopify-section-ID:
 *   - die Produkt-Grid-Section (main-collection-products, erkannt über #facet-filters)
 *   - die CLP-Komponenten-Section (.cc-clp-components) für die aktiven Filter-States
 * Custom-Elements (<clp-slider>, <facet-filters>) re-initialisieren sich beim Einfügen.
 * History via pushState/popstate. Bei Fehler → normaler Seiten-Reload (kein Datenverlust).
 */
(function () {
  'use strict';

  var FILTER_SEL = '.clp-filter-bar__pill, .clp-vendor-filter__tile';
  var EMPTY_SEL = '.clp-filter-bar__pill--empty, .clp-vendor-filter__tile--empty';

  function sectionOf(el) {
    return el ? el.closest('[id^="shopify-section-"]') : null;
  }

  function targets() {
    var clp = sectionOf(document.querySelector('.cc-clp-components'));
    var grid = sectionOf(document.getElementById('facet-filters'));
    if (!grid && clp) {
      var n = clp.nextElementSibling;
      while (n && !(n.id && n.id.indexOf('shopify-section-') === 0)) n = n.nextElementSibling;
      grid = n;
    }
    return { clp: clp, grid: grid };
  }

  function swap(currentEl, doc) {
    if (!currentEl || !currentEl.id) return false;
    var fresh = doc.getElementById(currentEl.id);
    if (!fresh) return false;
    currentEl.replaceWith(fresh);
    return true;
  }

  function navigate(url, updateHistory) {
    var t = targets();
    if (!t.grid) { window.location.href = url; return; }
    t.grid.classList.add('clp-ajax-loading');

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var gridOk = swap(t.grid, doc);
        if (!gridOk) throw new Error('grid section not found');
        // CLP-Section (Filter-States) tauschen — re-query, da grid evtl. davor lag
        swap(sectionOf(document.querySelector('.cc-clp-components')), doc);

        if (updateHistory !== false) history.pushState({ clpAjax: true }, '', url);

        var anchor = document.querySelector('.cc-clp-components') || document.getElementById('facet-filters');
        if (anchor && typeof anchor.scrollIntoView === 'function') {
          anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      })
      .catch(function () { window.location.href = url; });
  }

  document.addEventListener('click', function (e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    var link = e.target.closest(FILTER_SEL);
    if (!link || !link.href) return;
    if (link.matches(EMPTY_SEL)) { e.preventDefault(); return; }
    e.preventDefault();
    navigate(link.href, true);
  });

  window.addEventListener('popstate', function () {
    if (document.querySelector('.cc-clp-components')) navigate(location.href, false);
  });
})();
